import { render } from "./videophone.vue?vue&type=template&id=0d8383ec&scoped=true"
import script from "./videophone.vue?vue&type=script&lang=js"
export * from "./videophone.vue?vue&type=script&lang=js"

import "./videophone.vue?vue&type=style&index=0&id=0d8383ec&scoped=true&lang=css"

import exportComponent from "D:\\phpstudy_pro\\好好玩官网\\wan\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d8383ec"]])

export default __exports__